(function ($) {
    "use strict";

    var $html = $('html');
    var isTouch = $html.hasClass('touchevents');

    var $game = $('#game');
    setFontSize();

    var animatingScore = false;

    var level = 1;
    var score = 0;
    //var found = 0;

    var timer;
    var minutes = 1;

    var paused = true;
    var gameOver = false;
    var levelUpMode = false;

    var saved_game;
    var saved_level;
    var saved_timer;
    //var saved_found;

    var pics = [
        'images/bg1-2x.png',
        'images/bg2-2x.png',
        'images/bg3-2x.png',
        'images/btn.png',
        'images/car.png',
        'images/man.png',
        'images/man-up.png',
        'images/pies.png',
        'images/pies-left.png',
        'images/pies-right.png',
        'images/level0.png',
        'images/level1.png',
        'images/level2.png',
        'images/level3-after.png',
        'images/level3.png',
        'images/level4.png',
        'images/level5.png',
        'images/level6.png',
        'images/popup-start-game.png',
        'images/popup-end-game.png',
        'images/popup-rotate.png',
        'images/popup-level-up.png',
        'images/popup-dev.png',
        'images/rotate-phone.svg',
        'images/iquadart.svg',
        'images/hrodnalife.svg'
    ];

    var imgCurrent = 0, allLoaded = false;

    function imgPreload() {
        for (var i in pics) {
            var img = new Image();
            img.onload = function () {
                imgCurrent++;
                imgComplete();
            };
            img.onerror = function () {
                imgCurrent++;
                imgComplete();
            };
            img.src = pics[i];
        }
    }

    function imgComplete() {
        var percentBar = Math.floor(imgCurrent / pics.length * 100);
        $('#perc_loading').text(percentBar);
        if (imgCurrent >= pics.length && !allLoaded) {
            allLoaded = true;
            setTimeout(function () {
                $('.loading-wrapper').addClass('done');
                openPopup('popup-start');
                setTimeout(function () {
                    $('.loading-wrapper').remove();
                }, 300);
            }, 300);
        }
    }

    setTimeout(function () {
        imgPreload();
    }, 300);

    var updateTimer = function () {
        timer -= 50;

        // Every second
        if (timer >= 0 && timer % 1000 === 0) {
            $game.find('.time').data('timer', timer).text(formatTime(timer));
        }

        if (timer < 0) {
            if (level === 0) {
                restoreLevel();
            } else {
                gameOver = true;
                showGameOver();
            }
        }
    };

    setInterval(function () {
        if (paused || gameOver || levelUpMode) {
            return;
        }
        updateTimer();
    }, 50);


    $('#start_game').on('click', function (e) {
        e.preventDefault();
        closePopups(false);
        startNewGame();
        // goToNextLevel();
        // showEndGame();
    });

    var focusOut = false; // set true on blur only if not paused before
    $(window).on('focus', function () {
        if (focusOut) {
            resumeGame();
            $html.removeClass('game-paused');
        }
        focusOut = false;
    });
    $(window).on('blur', function () {
        if (!paused) {
            focusOut = true;
            pauseGame();
            $html.addClass('game-paused');
        } else {
            focusOut = false;
        }
    });

    function startNewGame() {
        level = 1;
        score = 0;
        //found = 0;
        timer = minutes * 60000;
        //_ajaxSwitchLevel();
        $game.addClass('no-transition faded');
        _ajaxLoadLevel();
    }

    function pauseGame() {
        paused = true;
    }

    function resumeGame() {
        paused = false;
    }

    function showTime() {
        $game.find('.time').data('timer', timer).text(formatTime(timer));
    }

    function showScore() {
        animatingScore = false;
        $game.find('.score').text(score).data('prev', score);
    }

    function startLevel() {
        showTime();
        showScore();
        setTimeout(function () {
            _initGame();
        }, 300);
    }

    function _initGame() {
        gameOver = false;
        resumeGame();

        var $level_items_counter = $game.find('.level-items-counter');
        var $game_field = $game.find('svg.game-field');

        // groups :hover
        $game_field.children('g').each(function () {
            var _this = this, $g = $(this);
            var isCover = $g.hasClass('cover');
            var isHidden = $g.hasClass('hidden');

            // todo: deal with touch
            if (!isTouch && !isCover) {

                if (!isHidden) {
                    tippy(_this, {
                        content: $g.data('title'),
                        delay: [600, 0],
                        duration: [200, 100],
                        theme: 'hr',
                        flipOnUpdate: true,
                        followCursor: true
                    });
                    $g.addClass('hover');
                }

                $g.hover(function () {
                    $g.removeClass('mistaked');
                }, function () {
                });
            }
        });

        $game_field.children('g').on('click', function () {
            var _this = this, $g = $(this);
            var isCover = $g.hasClass('cover');
            var isHidden = $g.hasClass('hidden');

            if (isCover || isHidden) {
                $game_field.children('g.hidden').each(function () {
                    var __this = this, _$g = $(this);
                    tippy(__this, {
                        content: _$g.data('title'),
                        delay: [600, 0],
                        duration: [200, 100],
                        theme: 'hr',
                        flipOnUpdate: true,
                        followCursor: true
                    });
                });
                $game_field.children('g.hidden').addClass('hover').removeClass('hidden');

                $game_field.children('g.cover').addClass('removing-cover');
                setTimeout(function () {
                    $game_field.children('g.cover').remove();
                }, 300);

                return;
            }

            if ($g.hasClass('denied') && !$g.hasClass('removed') && !$g.hasClass('clicked')) {
                var name = $g.data('name');
                var qty = $g.data('qty');

                var $counter = $level_items_counter.find('.item-counter-value.' + name);

                // already picked - show denied
                if ($counter.closest('.item-counter').hasClass('counter-complete')) {
                    animateDenied($g);
                    return;
                }

                $g.addClass('clicked');

                // increase score
                var multipler = level > 0 ? level : 10; // bonus level has x10
                var timer_sec = Math.ceil(timer / 10000) * 10, total_sec = minutes * 60;
                score += Math.ceil(Math.ceil((timer_sec * timer_sec * timer_sec) / (total_sec * total_sec * total_sec) * 10) * 10 * multipler);
                increaseScore();

                // count found items
                var type_current = parseInt($counter.text()) || 0;
                var type_limit = $counter.data('limit');
                var type_total = $counter.data('total');
                type_current += qty;
                $counter.text(type_current);
                if (type_total - type_current <= type_limit) {
                    $counter.closest('.item-counter').addClass('counter-complete');
                }

                // total count
                //var total = parseInt($level_items_counter.data('total')) || 0;
                //found++;
                if ($level_items_counter.find('.item-counter').length === $level_items_counter.find('.item-counter.counter-complete').length) {
                    // next level, exit bonus level or end game
                    if (level === 0) {
                        paused = true;
                        setTimeout(function () {
                            restoreLevel();
                        }, 300);
                    } else {
                        paused = true;
                        setTimeout(function () {
                            goToNextLevel();
                        }, 300);
                    }
                }

                $g.removeClass('hover');

                var $cloned = $g.clone();
                $cloned.addClass('removed');
                $cloned.insertBefore($g);

                if (!isTouch) {
                    _this._tippy.disable();

                    // removing animation
                    $g.addClass('removing');
                    setTimeout(function () {
                        $g.remove();
                    }, 300);
                } else {
                    $g.remove();
                }
            }

            if (!$g.hasClass('denied')) {
                animateDenied($g);
            }
        });
    }

    function animateDenied($g) {
        var $gg = $g.children('g');
        if (!$g.hasClass('mistaked')) {
            $g.addClass('mistaked').siblings('g').removeClass('mistaked');
            // decrease time
            timer = Math.max(timer - 10000, 0); // -10s
            var display_timer = $game.find('.time').data('timer');
            display_timer = Math.max(display_timer - 10000, 0);
            $game.find('.time').data('timer', display_timer).text(formatTime(display_timer));

            // debug: count mistakes
            //var $mistake_counter = $level_items_counter.find('.mistake-counter');
            //var mistakes = parseInt($mistake_counter.text()) || 0;
            //$mistake_counter.text(mistakes + 1);
        }
        if (!$gg.hasClass('shake-wrong')) {
            $gg.addClass('shake-wrong');
            setTimeout(function () {
                $gg.removeClass('shake-wrong');
            }, 600);
        }
    }

    function showEndGame() {
        $game.addClass('faded');
        setTimeout(function () {
            var rank = Math.min(Math.max(level - 1, 0), 5);
            $('.popup.popup-game-over .popup-title').text(textVars.endGameTitle);
            var text = textVars.endGameText.replace('{rank}', textVars.ranks[rank]);
            $('.popup.popup-game-over .end-game-text').html(text);
            $('.popup-score').text(score);
            _initSocial();
            openPopup('popup-game-over');
        }, 300);
    }

    function showGameOver() {
        $game.addClass('faded');
        setTimeout(function () {
            var rank = Math.min(Math.max(level - 1, 0), 5);
            $('.popup.popup-game-over .popup-title').text(textVars.gameOverTitle);
            var text = textVars.gameOverText.replace('{rank}', textVars.ranks[rank]);
            $('.popup.popup-game-over .end-game-text').text(text);
            $('.popup-score').text(score);
            _initSocial();
            openPopup('popup-game-over');
        }, 300);
    }

    function _initSocial() {
        $('.simple-share-container').html('').append('<div class="simple-share"/>');
        $('.simple-share').simpleShare({
            providers: {
                'odnoklassniki': {
                    name: 'odnoklassniki',
                    link: 'https://connect.ok.ru/offer?url={url}&title={title}',
                    title: textVars.okProvider,
                    width: 580,
                    height: 360
                }
            },
            enabledProviders: ['vk', 'facebook', 'twitter', 'odnoklassniki'],
            title: textVars.shareMsg + ' ' + score + ' ' + numCase(score, textVars.scoreWord[0], textVars.scoreWord[1], textVars.scoreWord[2])
        });
    }

    function restoreLevel() {
        paused = true;
        level = saved_level;
        timer = saved_timer;
        //found = saved_found;
        $game.addClass('faded');
        setTimeout(function () {
            $game.html(saved_game);
            $game.find('.level-picture').addClass('level-after');
            $game.removeClass('no-transition faded');
            startLevel();
        }, 300);
    }

    function goToNextLevel() {
        level++;
        if (level > 6) {
            gameOver = true;
            showEndGame();
            return;
        }
        paused = true;
        timer = minutes * 60000; // reset timer on next level
        //found = 0;
        $('.popup-to-level .popup-content').addClass('hidden');
        $('.popup-to-level .popup-content.to-level-' + level).removeClass('hidden');
        openPopup('popup-to-level');
    }

    function goToBonusLevel() {
        saved_level = level;
        saved_game = $('#game').html();
        saved_timer = timer;
        //saved_found = found;
        level = 0;
        paused = true;
        timer = minutes * 0.75 * 60000; // reset timer on next level
        //found = 0;
        _ajaxSwitchLevel();
    }

    function _ajaxSwitchLevel() {
        $game.addClass('faded');
        setTimeout(function () {
            _ajaxLoadLevel();
        }, 300);
    }

    function _ajaxLoadLevel() {
        $game.load('level.php?level=' + level, function () {
            $game.removeClass('no-transition faded');
            startLevel();
        });
    }

    $(document).on('click', 'button.next_level', function () {
        closePopups(false);
        _ajaxSwitchLevel();
    });

    $(document).on('click', 'button.test_next_level', function () {
        goToNextLevel();
    });

    $(document).on('click', 'button.bonus_level', function () {
        $(this).hide();
        goToBonusLevel();
    });

    $(document).on('click', 'button.back_to_level', function () {
        restoreLevel();
    });

    $(document).on('click', 'button.reset_game', function () {
        //$game.addClass('no-transition faded');
        closePopups(false);
        startNewGame();
    });

    $(document).on('click', 'button.want_reset_game', function () {
        openPopup('popup-confirm-reset');
    });

    $(document).on('click', '.open_rules', function () {
        openPopup('popup-rules');
    });

    $(document).on('click', '.back_to_game', function () {
        closePopups(true);
    });

    function closePopups(resume) {
        if (resume) {
            $game.removeClass('faded');
            resumeGame();
        }
        $('body').removeClass('opened-popup');
        $('.popup').addClass('hidden');
    }

    function openPopup(name) {
        pauseGame();
        $game.addClass('faded');
        $('body').addClass('opened-popup');
        $('.popup.' + name).removeClass('hidden');
    }

    if ($('#debug').length) {
        $(document).on('mousemove', function (e) {
            var wscale = $game.find('svg.game-field').width() / 1000;
            var x = Math.max(0, (e.clientX - $game.find('svg.game-field').offset().left + $(window).scrollLeft()) / wscale);
            var y = Math.max(0, (e.clientY - $game.find('svg.game-field').offset().top + $(window).scrollTop()) / wscale);
            x = Math.min(Math.round(x * 10) / 10, 1000);
            y = Math.min(Math.round(y * 10) / 10, 1000);
            $('#debug').text(x + ' ' + y);
        });
    }

    function formatTime(ms) {
        var sec = Math.floor(ms / 1000);
        var min = Math.floor(sec / 60);
        sec = sec % 60;
        return '' + (min < 10 ? '0' + min : min) + ':' + (sec < 10 ? '0' + sec : sec);
    }

    function increaseScore() {
        var $current_score = $game.find('.score');
        animatingScore = false;
        if ($(window).width() < 1000) {
            $current_score.text(score);
        } else {
            var prev = $current_score.data('prev');
            $current_score.data('prev', score);
            animatingScore = true;
            animateIncreaseScore(prev, score, Math.ceil((score - prev) / 20));
        }
    }

    function animateIncreaseScore(value, to, range) {
        var $current_score = $game.find('.score');
        if (animatingScore) {
            if (value >= to) {
                value = to;
                animatingScore = false;
            }
            $current_score.text(value);
            if (animatingScore) {
                setTimeout(function () {
                    animateIncreaseScore(value + range, to, range);
                }, 10);
            }
        } else {
            $current_score.text(to);
        }
    }

    function numCase(num, one, two, five) {
        var text = '';
        if (num > 100) {
            num = num % 100;
        }
        if (num >= 5 && num <= 20) {
            text = five;
        } else {
            var ost = num % 10;
            if (ost === 1) {
                text = one;
            } else if (ost > 1 && ost < 5) {
                text = two;
            } else {
                text = five;
            }
        }
        return text;
    }

    $(window).resize(function(){
        setFontSize();
    });

    $(window).on('orientationchange', function(){
        setFontSize();
    });

    function setFontSize() {
        var gameWidth = $('#game').width();
        var fSize = Math.min(1600, gameWidth);
        fSize = Math.max(fSize / 1600, 0.5);
        $game.css('font-size', fSize + 'rem');
    }

    function dechex(number) {
        if (number < 0) {
            number = 0xFFFFFFFF + number + 1
        }
        return parseInt(number, 10).toString(16)
    }

})(jQuery);
